import Cookie from 'js-cookie';

/** Cookie options: shared across *.atoplatform.com in production. */
export function authCookieOptions() {
    const opts = { expires: 90, sameSite: 'lax' };
    if (typeof window !== 'undefined' && window.location.hostname.endsWith('atoplatform.com')) {
        opts.domain = '.atoplatform.com';
    }
    return opts;
}

/** Resolve JWT from localStorage (primary) or shared cookie (cross-subdomain). */
export function getAuthToken() {
    if (typeof window === 'undefined') return null;

    try {
        const raw = localStorage.getItem('user');
        if (raw) {
            const user = JSON.parse(raw);
            if (user && user.token && typeof user.token === 'string') {
                return user.token;
            }
        }
    } catch (e) {
        // ignore corrupt localStorage
    }

    const cookieToken = Cookie.get('token');
    if (cookieToken && cookieToken !== '[object Object]') {
        return cookieToken;
    }

    return null;
}

export function setAuthToken(token) {
    Cookie.set('token', token, authCookieOptions());
}

export function clearAuthToken() {
    const opts = authCookieOptions();
    Cookie.remove('token', opts);
    Cookie.remove('token');
    localStorage.removeItem('user');
}
